import { useState, useEffect, useReducer } from "react";
import ProductsTable from "../../components/products/ProductsTable";
import { Product } from "../../components/products/ProductInterface";
import { getProducts, putProduct } from "../../services/products/productAxios";
import Loader from "../../components/common/Loader";
import ProductsTableSkeleton from "../../components/skeleton/ProductsTableSkeleton";
import { enqueueSnackbar } from "notistack";
// import { useCurrency } from "../../context/Currency";
import { useAuth } from "../../context/AuthContext";
import { dictionary } from "../../utils/dictionary";
import ProductsHeader from "../../components/products/ProductsHeader";
import {
  productsReducer,
  initialProductState,
} from "../../reducers/productPage/ProductPageReducer";
import toast from "react-hot-toast";

export default function ProductPage() {
  const { language } = useAuth();
  const [productsState, dispatchProducts] = useReducer(
    productsReducer,
    initialProductState
  );

  useEffect(() => {
    dispatchProducts({ type: "INIT_FETCH_PRODUCTS" });
    getProducts()
      .then((products) => {
        dispatchProducts({ type: "SET_PRODUCTS", payload: products });
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        enqueueSnackbar("Error fetching products", { variant: "error" });
        dispatchProducts({ type: "SET_ERROR", payload: error });
      });
  }, []);

  const saveAllChanges = async () => {
    if (productsState.editingIds.size === 0) return;
    
    const updatedProducts = productsState.products.map(product => {
      if (productsState.editingIds.has(product.id)) {
        const editValues = productsState.editValuesMap[product.id];
        return {
          ...product,
          name: editValues.name,
          price: parseFloat(editValues.price),
        };
      }
      return product;
    }).filter(product => productsState.editingIds.has(product.id));
    
    try {
      await Promise.all(updatedProducts.map(async product => {
        await putProduct(product)
    }));
      
      dispatchProducts({ type: "SAVE_CHANGES" });
      toast.success(`${updatedProducts.length} ${dictionary["products-updated-successfully"][language] || "products updated successfully"}`);
      
    } catch (error) {
      console.error("Error updating products:", error);
      toast.error(dictionary["error-updating-products"][language] || "Error updating products. Please try again.");
    }
  };

  if (productsState.isLoading) {
    return (
      <div className="min-h-screen bg-[#F5F6FA] p-16 font-['Plus_Jakarta_Sans']">
        <ProductsHeader
          title={dictionary["products"][language]}
          description={dictionary["products-page-description"][language]}
        />
        <div className="mt-4">
          <ProductsTableSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F5F6FA] p-16 font-['Plus_Jakarta_Sans']">
      <ProductsHeader
        title={dictionary["products"][language]}
        description={dictionary["products-page-description"][language]}
        productsState={productsState}
        dispatchProducts={dispatchProducts}
        onSaveChanges={saveAllChanges}
      />
      <div className="mt-4">
        <ProductsTable
          productsState={productsState}
          dispatchProducts={dispatchProducts}
        />
      </div>
    </div>
  );
}
